import { ResolverTag } from '@ps/web-core-enums';
import type { TranslationTag } from '@ps/web-core-intl';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';

import {
  TXTWCL_Anytime_GoalscorerX_If_the_sel_ELL,
  TXTWCL_Early_payout_if_your_team_goes_ELL,
  TXTWCL_Get_paid_out_early_if_youXre_w_ELL,
  TXTWCL_If_the_selected_player_is_subs_ELL
} from './TermsAndConditions.messages.json';
import styles from './TermsAndConditions.scss';

interface Props {
  termsAndConditions: string;
}

interface TermsAndConditionsTags {
  translationTag: TranslationTag;
  resolverTag: ResolverTag;
}

const termsAndConditionsMap: Partial<Record<string, TermsAndConditionsTags>> = {
  ISP_I18N_STAR_SUB_TERMS_AND_CONDITIONS: {
    resolverTag: ResolverTag.ISPStarSubTerms,
    translationTag: TXTWCL_If_the_selected_player_is_subs_ELL
  },
  ISP_I18N_STAR_SUB_GOALSCORER_TERMS_AND_CONDITIONS: {
    resolverTag: ResolverTag.ISPStarSubTerms,
    translationTag: TXTWCL_Anytime_GoalscorerX_If_the_sel_ELL
  },
  ISP_I18N_TWO_UP_TERMS_AND_CONDITIONS: {
    resolverTag: ResolverTag.HelpGamesSportsFootballRules,
    translationTag: TXTWCL_Early_payout_if_your_team_goes_ELL
  },
  ISP_I18N_MATCH_ODDS_NINETY_TERMS_AND_CONDITIONS: {
    resolverTag: ResolverTag.HelpGamesSportsFootballRules,
    translationTag: TXTWCL_Get_paid_out_early_if_youXre_w_ELL
  }
};

const TermsAndConditions: React.FC<Props> = ({ termsAndConditions }) => {
  const resolverTagAndTranslationMap = termsAndConditionsMap[termsAndConditions];

  if (!resolverTagAndTranslationMap) {
    return null;
  }
  const { resolverTag, translationTag } = resolverTagAndTranslationMap;

  return (
    <div className={styles.termsAndConditions}>
      <Translation
        {...translationTag}
        values={{
          a: (msg: React.ReactNode) => <ResolverLink resolverTag={resolverTag}>{msg}</ResolverLink>
        }}
      />
    </div>
  );
};

export default TermsAndConditions;
